module.exports = __webpack_public_path__ + "static/media/cert_162.fddc58f8.jpg";